import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col, Menu } from "antd";
import { URLS, SOURCE_KHOPOLI } from "../../constants";
import logo_red from "../../assets/logo_red.svg";
import logo_khopoli from "../../assets/amns_khopoli.png";
import Slider from "./Slider";
import "swfrontend/MDMApp.css";

class CRPHeader extends Component {
  handleClick = (e) => {
    this.setState({
      selectedKeys: [URLS + e.key],
    });
    this.props.history.push({
      pathname:
        URLS.BASEROUTE + (URLS.BASEROUTE === "/" ? "" + e.key : "/" + e.key),
    });
  };

  render() {
    const pathname = this.props.history.location.pathname;

    return (
      <div>
        <div span={24}>
          <Row>
            <Col span={6} className="header-new">
              <img src={pathname.includes(SOURCE_KHOPOLI) ? logo_khopoli : logo_red} alt="" className={
                pathname.includes(SOURCE_KHOPOLI) ? "logo-khopoli" : "logo"
              } />
            </Col>

            <Col span={18}>
              <Menu
                className="header-new"
                mode="horizontal"
                onClick={this.handleClick}
                selectedKeys={[this.props.currentRoute]}
                defaultOpenKeys={["sub1"]}
              >
                <Menu.Item key="Home" id="home">
                  Home
                </Menu.Item>
                <Menu.Item key="Registration" id="registration">
                  Customer Registration
                </Menu.Item>
                <Menu.Item key="ContactUs" id="contact">
                  Contact Us
                </Menu.Item>
                <Menu.Item key="Login" id="login">
                  Login
                </Menu.Item>
              </Menu>
            </Col>
          </Row>
        </div>

        {pathname === URLS.BASEROUTE || pathname.includes("Home") ? (
          <Slider />
        ) : null}
      </div>
    );
  }
}

export default withRouter(CRPHeader);
